import { userFilterCategories } from "../../../shared/lookup";
const workflows = [
    {
        id: 4,
        title: '$PM_NAME Instructions',
        notificationName: 'Instruction',
        abbreviation: '$PM_ABBREVIATION-Instruction-',
        notifyingParty: 'PM',
        replyingParty: 'SUPPLIER',

        replyEnabled: false,
        replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
        replyPeriod: 0,

        resubmitPeriodOption: "PM_REPLY_PERIOD",
        resubmitPeriod: 0,

        notify: true,
        assetFieldsEnabled: false,

        form_IncludeCompanyName: false,
        form_CompanyName: 'PARTY',
        form_CompanyLogo: 'PARTY',


        notifyAttachments: true,
        replyAttachments: true,

        includePdfjson: false,
        internalEstimatesEnabled: true,

        config: {
            description: 'PM to Supplier Instructions',
            currentModel: 'InspectionDefect',
            currentModelType: 'Instruction',
            referenceType: 'PMInstruction',
            documentType: 'Document143pm',


            showInRelations: true,
            showInCustomFields: true,
            notifyPossible: true,
            replyPossible: true,
            configurableReplyTab: true,
            configurableAssets: true,
            configurableReplyingParty: true,
            configurableInternalEstimates: true,

            replyPeriodOptions: ["SUPPLIER_REPLY_PERIOD", "CUSTOM", "ASKED_ON_COMMUNICATION_FORM"],
            resubmitPeriodOptions: ["PM_REPLY_PERIOD", "CUSTOM"],
            userFilterCategories: [
                userFilterCategories.ACCESS,
                userFilterCategories.MAIN_NOTICE,
                userFilterCategories.REPLY_NOTICE,
                userFilterCategories.NOTIFY
            ],
            paths: {
                base: 'pm',
                create: 'create',
                list: 'list',
                default: 'list'
            }
        }
    },
    {
        id: 56,
        title: '$CLIENT_NAME Instructions',
        path: '',
        notificationName: 'Instruction',
        abbreviation: '$CLIENT_NAME-Instruction-',
        notifyingParty: 'CLIENT',
        replyingParty: 'PM',

        replyEnabled: false,
        replyPeriodOption: "PM_REPLY_PERIOD",
        replyPeriod: 0,

        resubmitPeriodOption: "CLIENT_REPLY_PERIOD",
        resubmitPeriod: 0,

        notify: true,
        assetFieldsEnabled: false,

        form_IncludeCompanyName: false,
        form_CompanyName: 'PARTY',
        form_CompanyLogo: 'PARTY',


        notifyAttachments: true,
        replyAttachments: true,

        includePdfjson: false,
        internalEstimatesEnabled: true,

        config: {
            description: 'Client to PM Instructions',
            currentModel: 'InspectionDefect',
            currentModelType: 'InstructionClient',
            referenceType: 'PMInstruction',
            documentType: 'DocumentInstructionClient',


            showInRelations: true,
            showInCustomFields: true,
            notifyPossible: true,
            replyPossible: true,
            configurableReplyTab: true,
            configurableAssets: true,
            configurableReplyingParty: true,
            configurableInternalEstimates: true,

            replyPeriodOptions: ["PM_REPLY_PERIOD", "CUSTOM", "ASKED_ON_COMMUNICATION_FORM"],
            resubmitPeriodOptions: ["CLIENT_REPLY_PERIOD", "CUSTOM"],

            userFilterCategories: [
                userFilterCategories.ACCESS,
                userFilterCategories.MAIN_NOTICE,
                userFilterCategories.REPLY_NOTICE,
                userFilterCategories.NOTIFY
            ],
            paths: {
                base: 'client',
                create: 'create',
                list: 'list',
                default: 'list'
            }
        }
    },
    {
        id: 61,
        title: '$SUPERVISOR_NAME Instructions',
        notificationName: 'Instruction',
        abbreviation: '$SUPERVISOR_NAME-Instruction-',
        notifyingParty: 'SUPERVISOR',
        replyingParty: 'SUPPLIER',

        replyEnabled: false,
        replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
        replyPeriod: 0,

        resubmitPeriodOption: "SUPERVISOR_REPLY_PERIOD",
        resubmitPeriod: 0,

        notify: true,
        assetFieldsEnabled: false,

        form_IncludeCompanyName: false,
        form_CompanyName: 'PARTY',
        form_CompanyLogo: 'PARTY',


        notifyAttachments: true,
        replyAttachments: true,

        includePdfjson: false,
        internalEstimatesEnabled: true,

        config: {
            description: 'Supervisor to Supplier Instructions',
            currentModel: 'InspectionDefect',
            currentModelType: 'InstructionSupv',
            referenceType: 'PMInstruction',
            documentType: 'DocumentInstructionSupv',


            showInRelations: true,
            showInCustomFields: true,
            notifyPossible: true,
            replyPossible: true,
            configurableReplyTab: true,
            configurableAssets: true,
            configurableReplyingParty: true,
            configurableInternalEstimates: true,

            replyPeriodOptions: ["SUPPLIER_REPLY_PERIOD", "CUSTOM", "ASKED_ON_COMMUNICATION_FORM"],
            resubmitPeriodOptions: ["SUPERVISOR_REPLY_PERIOD", "CUSTOM"],

            userFilterCategories: [
                userFilterCategories.ACCESS,
                userFilterCategories.MAIN_NOTICE,
                userFilterCategories.REPLY_NOTICE,
                userFilterCategories.NOTIFY
            ],
            paths: {
                base: 'supervisor',
                create: 'create',
                list: 'list',
                default: 'list'
            }
        }
    }
]

export default workflows;